export default "__VITE_PUBLIC_ASSET__fd52ebc6__"